import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-community-forum',
  templateUrl: './community-forum.component.html',
  styleUrls: ['./community-forum.component.scss']
})
export class CommunityForumComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
